import { Link } from 'react-router-dom';
import { siteConfig, services } from '../../mocks/siteData';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer style={{ backgroundColor: '#0e0e0e' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">

          {/* Brand Column */}
          <div className="lg:col-span-4">
            <div className="mb-6">
              <div className="font-condensed text-white text-2xl font-bold tracking-widest uppercase leading-none">
                OTT <span className="text-gold">CAR CARE</span>
              </div>
              <div className="text-white/30 text-[10px] tracking-[0.35em] uppercase font-sans mt-1">
                Over The Top · Nationwide
              </div>
            </div>
            <p className="text-white/40 text-sm font-sans leading-relaxed max-w-xs mb-8">
              Nationwide automotive event management, vehicle display, fleet detailing, and program support for OEMs, agencies, and dealer groups across all 50 states.
            </p>
            <div className="flex flex-col gap-3 text-sm font-sans">
              <div className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-gold text-sm" />
                </div>
                <span className="text-white/40">{siteConfig.addressLine1}, {siteConfig.addressLine2}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-gold text-sm" />
                </div>
                <a href={siteConfig.phoneHref} className="text-white/40 hover:text-gold transition-colors cursor-pointer">
                  {siteConfig.phone}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-earth-line text-gold text-sm" />
                </div>
                <span className="text-gold/60 text-xs uppercase tracking-wider font-medium">Serving All 50 States</span>
              </div>
            </div>
            <div className="flex gap-3 mt-8">
              <a href={siteConfig.social.instagram} target="_blank" rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-gold/20 text-gold/40 hover:text-gold hover:border-gold/50 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm" />
              </a>
              <a href={siteConfig.social.facebook} target="_blank" rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-gold/20 text-gold/40 hover:text-gold hover:border-gold/50 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-sm" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="lg:col-span-3">
            <h4 className="text-[10px] font-sans font-semibold tracking-[0.3em] uppercase text-gold mb-6">
              Services
            </h4>
            <ul className="flex flex-col gap-3">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`}
                    className="text-white/40 hover:text-white text-sm font-sans transition-colors cursor-pointer leading-snug block">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="lg:col-span-2">
            <h4 className="text-[10px] font-sans font-semibold tracking-[0.3em] uppercase text-gold mb-6">
              Company
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Home', href: '/' },
                { label: 'About OTT', href: '/about' },
                { label: 'All Services', href: '/services' },
                { label: 'Coverage', href: '/location/lake-forest' },
              ].map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-white/40 hover:text-white text-sm font-sans transition-colors cursor-pointer">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Block */}
          <div className="lg:col-span-3">
            <h4 className="text-[10px] font-sans font-semibold tracking-[0.3em] uppercase text-gold mb-6">
              Start a Program
            </h4>
            <p className="text-white/40 text-sm font-sans leading-relaxed mb-6">
              Planning an event, launch, or fleet program? Let's talk about what OTT can deliver for your brand.
            </p>
            <Link to="/services"
              className="inline-block bg-gold hover:bg-gold-light text-[#0A0A0A] text-sm font-sans font-semibold px-6 py-3 uppercase tracking-wide transition-colors cursor-pointer whitespace-nowrap">
              Plan Your Program
            </Link>
            <div className="mt-6 pt-6 border-t border-white/10">
              <a href={siteConfig.phoneHref}
                className="flex items-center gap-2 text-white/50 hover:text-gold transition-colors text-sm font-sans cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-gold text-sm" />
                </div>
                {siteConfig.phone}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/20 text-xs font-sans">
            &copy; {year} {siteConfig.fullName}. All Rights Reserved. HQ: Lake Forest, CA
          </p>
          <p className="text-white/20 text-xs font-sans tracking-wider uppercase">
            Nationwide Automotive Event Services
          </p>
        </div>
      </div>
    </footer>
  );
}
